module.exports = __webpack_public_path__ + "media/images/top/icon/white/ico_plus-a1244c5787f263cbd25730d8d498abe6.svg";